import { MODERN_THEMES } from './modern-themes';
import type { ThemeMode, ThemeName } from './types';

export type ThemeOption = {
  readonly key: string;
  readonly displayName: string;
  readonly themeName: ThemeName;
  readonly themeMode: ThemeMode;
  readonly legacyFallback: string;
};

export const THEME_OPTIONS = [
  {
    key: 'trellis-light',
    displayName: 'Teal',
    themeName: 'trellis',
    themeMode: 'light',
    legacyFallback: 'trellis-light',
  },
  {
    key: 'navy-light',
    displayName: 'Navy',
    ...MODERN_THEMES['navy-light'],
  },
] as const satisfies readonly ThemeOption[];
